import { Component, OnDestroy, OnInit } from "@angular/core";
import moment from "moment";
import { map, share, Subscription, timer } from "rxjs";
import { PosService } from "src/app/core/services/pos.service";

@Component({
	selector: "app-pos-idle",
	templateUrl: "./pos-idle.component.html",
	styleUrls: ["./../pos.scss"],
})
export class PosIdleComponent implements OnInit, OnDestroy {
	clock: Subscription;
	clockTime = new Date();

	moment: any = moment;

	constructor(public posService: PosService) {}
	ngOnDestroy(): void {
		if (this.clock) {
			this.clock.unsubscribe();
		}
	}

	ngOnInit(): void {
		this.clock = timer(0, 1000)
			.pipe(map(() => new Date(), share()))
			.subscribe((time) => (this.clockTime = time));
	}
}
